export default "__VITE_ASSET__P9gy6lhn__"